<div class="item-container">
    <div class="item-header">
      <h5 class="text-center">Sign</h5>
      <div class="edit-icons" mat-dialog-close>
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center" >
        <div class="signature-container mt-3" id="wrapper" #signbox>
            <canvas #signPadCanvas class="sign-box" (endStroke)="onEndStroke($event)" ></canvas>
        </div>
    </div>
    <div class="btn-container d-flex mt-4">
        <button color="" class="auth-form-btn outline-btn new-outline d-flex align-items-center justify-content-center"
          (click)="clearSignPad()">{{"MENUITEMS.CERTIFICATEMANAGEMENT.CLEAR"|translate}}</button>
        <button mat-raised-button color="warn" class="auth-form-btn  success-btn ms-3" type="submit"
           (click)="saveSignPad()" >{{ "BUTTON.SAVE" | translate }}</button>
    </div>
  </div>
  <app-loading-spinner></app-loading-spinner>